import React from 'react'
import { useSelector } from 'react-redux'

import { myOrganizationPropSelector } from 'domains/authentication/selectors/organizations'
import { RootState } from 'lib/store/rootReducer'
import { NON_MEMBER_ORG_MEMBERSHIP_DISPLAY } from 'domains/orgs/constants/organization'
import DrawerLink from 'domains/application/components/DrawerLink'

import colors from 'lib/styles/colors'
import theme from 'lib/styles/theme'

interface IProps {
  open: boolean
}

export default function JoinIMSDrawerLink(props: IProps) {
  const membershipLevel = useSelector((state: RootState) =>
    myOrganizationPropSelector('membershipLevel', '')(state, {}),
  )

  const isNonMember = membershipLevel === NON_MEMBER_ORG_MEMBERSHIP_DISPLAY

  if (!isNonMember) {
    return null
  }

  return (
    <DrawerLink
      title="Join 1EdTech"
      titleFontWeight={theme.fontWeights.title}
      icon={'fas fa-handshake'}
      iconColor={colors.background}
      bg={colors.primary}
      hoverBg={colors.tertiary}
      route="https://www.1edtech.org/about/membership"
      open={props.open}
      external={true}
      requiredRoles={[]}
    />
  )
}
